import React from "react";
import {IoLogoWhatsapp} from "react-icons/io5";

const Contratar = () => {
    return (

        <div className={'bg-whiteBG py-10  px-5 flex items-center flex-col justify-center'}>

            {/* background gradient */}
            <div
                className='w-[70%]  rounded-xl  h-2/6 bg bg-contain bg-bottom flex flex-col items-center justify-end'
                id='gradient2'>
                {/* background image */}
                <div
                    className='w-full h-60 bg-contain bg-center bg-[url("/assets/WithLettersRaul3-mobile.png")] ] bg-no-repeat'
                    id='home'></div>
                {/*<a className={`w-[252px] h-9 p-3  text-md font-medium bg-sbPallet-accent rounded-lg flex items-center justify-center opacity-0 ${opacity} transition-opacity duration-1000 ease-in-out`} href="#">
                    Comienza tu cambio
                </a>*/}
            </div>
            {/* Call to action */}
            <div
                className={`flex md:px-8 justify-center xl:justify-center text-bgBlack   transition-all duration-1000 ease-out`}>
                <div className='md:w-[484px] pt-[10px]  mx-20 flex flex-col justify-center'>
                    <h1 className='text-3xl md:text-5xl leading-8 font-black text-center mt-[18px]'><strong
                        className='text-sbPallet-accent'>Pasos a seguir</strong></h1>


                </div>

            </div>
            {/*paso 1*/}
            <div className={`mt-3 mb-2 mx-10 lg:mt-12 lg:text-3xl lg:mb-5 text-left flex items-center justify-start
                transition-all duration-1000 ease-out`}>
                <h3 className='text-3xl font-bold ml-10  text-sbPallet-accent'>1</h3>
                <p className="font-bold  text-bgBlack ml-3 ">Completar el formulario</p>
            </div>

            <p className="font-light break-words w-[60%] text-bgBlack lg:text-2xl  text-justify ml-5 ">Necesito que completes un formulario
                con información relevante a la hora de planificar tu preparación, solo te tomará unos minutos.</p>
   {/*         <p className="font-light break-words text-bgBlack  text-center ml-3 "><span className={'font-medium'}>Bizum :  </span>
                600803185  <br/><span className={'font-medium'}>Tranferencia bancaria</span><br/>
                (Santander)<br/> ES9400496827732110005450</p>*/}

            {/*paso 2*/}
            <div className={`mt-3   mb-2 mx-10 lg:mt-12 lg:mb-5  text-left lg:text-3xl flex items-center justify-start
                transition-all duration-1000 ease-out`}>
                <h3 className='text-3xl ml-10 font-bold text-sbPallet-accent'>2</h3>
                <p className="font-bold text-bgBlack ml-3 ">Realizar el pago</p>


            </div>
            <p className="font-light break-words w-[60%] lg:text-2xl text-bgBlack  text-justify ml-5 ">Tras rellenar el formulario, obtendrás la información necesaria para realizar el pago. La planificación se entregará una vez se realice el pago.</p>


            {/*paso 2*/}
            <div className={`mt-3   mb-2 mx-10 lg:mt-12 lg:text-3xl lg:mb-5 text-left flex items-center justify-start
                transition-all duration-1000 ease-out`}>
                <h3 className='text-3xl ml-10 font-bold text-sbPallet-accent'>3</h3>
                <p className="font-bold  text-bgBlack ml-3 ">Me pondré en contacto contigo.</p>

            </div>
            <p className="font-light break-words w-[60%] text-bgBlack  lg:text-2xl text-justify ml-5 ">Una vez completado el formulario y pago me pondré en contacto y comenzaremos con tu preparación.
            </p>

            {/*<a href={"https://api.whatsapp.com/send/?phone=34600803185&text&type=phone_number&app_absent=0"}
               className="w-[50px] h-[50px] rounded-full bg-whiteBG hover:bg-sbPallet-accent flex items-center justify-center group ease-in duration-100">
                <IoLogoWhatsapp
                    className="text-black group-hover:text-whiteBG  ease-in duration-100"
                    size={40}/>
            </a>*/}

            {/*boton rellenar formulario*/}
              <a className={`w-[212px] h-9 lg:w-[312px] lg:h-[52px] lg:my-10 lg:text-xl mb-10 transition-opacity duration-4000 p-3 mt-5
                 text-lg font-medium bg-sbPallet-accent rounded-lg flex items-center justify-center`}
                       href="https://docs.google.com/forms/d/e/1FAIpQLSfF2On4f-8wemHm4qf97PZYW7lemUMTXCznxwbx6U5WwqWd3w/viewform">Rellenar formulario</a>

        </div>
    )
}

export default Contratar;